function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", {
  id: "errorIconTitle"
}, "Error");

var _ref3 = /*#__PURE__*/React.createElement("desc", {
  id: "errorIconDesc"
}, "Error icon");

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M15.372 13.35l4.342-4.342c.544-.544.53-1.45-.014-1.994a1.43 1.43 0 0 0-2.001-.007l-4.335 4.335L9.023 7c-.545-.544-1.45-.53-1.995.014a1.43 1.43 0 0 0-.007 2.001l4.335 4.335-.007.007-4.335 4.335c-.544.544-.53 1.45.014 1.994.545.544 1.45.558 1.995.014l4.341-4.342.007.007 4.335 4.335c.544.544 1.45.53 1.994-.014.544-.545.558-1.45.014-1.994l-4.342-4.342zM3.91 3.91c5.219-5.218 13.668-5.211 18.88 0C28 9.122 28 17.578 22.79 22.79 17.578 28 9.122 28 3.91 22.79-1.3 17.578-1.3 9.122 3.91 3.91z"
});

var SvgCross = function SvgCross(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 27 27",
    fill: "currentColor",
    "aria-labelledby": "errorIconTitle errorIconDesc",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", {
    id: "errorIconTitle"
  }, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCross, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cross.0243674a.svg";
export { ForwardRef as ReactComponent };